export const CAC_COLUMN_ROW_CROSSTAB_MIN_COUNT = 3;
export const CAC_MAXIMUM_PROJECT_COUNT = 15;
export const CAC_MODULE_TITLE = 'Correspondence & Cluster';
export const CAC_MAX_LIMIT_REACHED_LABEL =
  'The max number of 15 projects have been created in the View panel, please close existing projects to proceed.';
/* pipe in next line is used to split text */
export const INSUFFICIENT_DATA_MODAL_TEXT = 
  `The data you have selected is not sufficient to render the Correspondence map.|
  Please ensure the report has at
 least ${CAC_COLUMN_ROW_CROSSTAB_MIN_COUNT} columns and ${CAC_COLUMN_ROW_CROSSTAB_MIN_COUNT} rows.`;
export const TAB_MIN_WIDTH = '220px';
export const CAC_LEFT_PANEL_VIEW_LABEL = 'view';
export const CAC_LEFT_PANEL_BUILD_LABEL = 'build';
export const CAC_NEW_PROJECT_NAME_LABEL = 'Untitled';
export const CAC_CREATE_NEW_PROJECT = 'New';
export const CAC_DUPLICATE_PROJECT = 'Duplicate';
export const CAC_EDIT_PROJECT_NAME = 'Edit Project Name';
export const CAC_PROJECT_TITLE_LENGTH = 60;
export const CAC_OPEN_SELECTED_PROJECTS_EXCEEDED_LABEL =
  'Only 15 projects can be opened at once, please unselect below or close opened tabs to proceed.';
export const CAC_NO_SAVED_PROJECTS_LABEL =
  'Sorry, There are no saved projects in your account';
export const CAC_SAVE_PROJECT_BEFORE_CLOSE_LABEL =
  'You have not saved this project, would you like to save it?';
export const CAC_VIEW_PANEL_CARD_DISPLAY = 'Card Display';
export const CAC_CORR_MODEL_PERFORMANCE_BODY = 
`A total variance above 65% will create a map with enough relative strength for statistically valid data.
 Total variance is calculated from the sum of the variance on each axis.`;
export const CAC_CLUST_MODEL_PERFORMANCE_BODY = 
`The application uses the Elbow Method to determine the most efficient cluster solution.
 This is the point where increasing the number of clusters (segments) no longer
 contributes to the increase of total variance explained significantly.`;
export const CAC_AXES_EXPLAINATION = `Front View represents Axis 1 and Axis 2, 
  Side View represents Axis 2 and Axis 3, 
  Top View represents Axis 1 and Axis 3.`;
export const CAC_CORR_COLUMN_TABLE = 'Columns';
export const CAC_CORR_ROW_TABLE = 'Rows';
export const CAC_CORR_AXES_TABLE = 'Axes';
export const CAC_CORR_MAX_AXES = 3;
export const CAC_CLUSTER_SEGMENT_TABLE_ROW_HEADERS = [
  'Sample Size',
  'Segment Size (Weighted)',
];
export const CAC_CLUSTER_SEGMENT_INDEX = {
  label: 'INDEX',
  value: 'index',
  hoverValue: 'index'
};
export const CAC_CLUSTER_SEGMENT_MEAN = {
  label: 'MEAN',
  value: 'mean',
  hoverValue: 'mean'
};
export const CAC_CLUSTER_SEGMENT_STANDARD_DEVIATION = {
  label: 'MEAN VARIANCE',
  value: 'stdDevMean',
  hoverValue: 'The Mean Variance indicates the number of Standard Deviations of the differences between the Cluster Mean and the General Mean'
};
export const CAC_CLUSTER_SEGMENT_ABSOLUTE_DEVIATION = {
  label: 'ABSOLUTE MEAN VARIANCE',
  value: 'absDevMean',
  hoverValue: 'The Absolute Mean Variance indicates the differences between the cluster mean and the general mean, the larger the differences is, the more significant the cluster'
};
export const CAC_CLUSTER_BY_RESPONDENTS = [
  { label: 'COLUMNS', key: 'cols' },
  { label: 'ROWS', key: 'rows' },
];
export const CAC_CLUSTER_BY_RESPONDENTS_DEFAULT_VAL = 'cols'; 
export const ADD_TO_PASSIVE_EVENT = 'ADD_TO_PASSIVE_EVENT'; 
export const SHOW_HIDE_DATAPOINT_EVENT = 'SHOW_HIDE_DATAPOINT_EVENT'; 
export const HANDLE_CLUSTER_BY_SWITCH_EVENT = 'HANDLE_CLUSTER_BY_SWITCH_EVENT'; 
export const HANDLE_VIEW_SWITCH_EVENT = 'HANDLE_VIEW_SWITCH_EVENT'; 
export const HANDLE_CHANGE_CLUSTER_SIZE = "HANDLE_CHANGE_CLUSTER_SIZE";
export const HANDLE_CORR_CHANGE_LABEL = "HANDLE_CORR_CHANGE_LABEL";
export const CAC_CORR_ACTIVE_TABLE = 'corrActiveTable';
export const CAC_CORR_TABLE_TYPE = 'corrTableType';
export const CAC_CLUSTER_ACTIVE_TABLE = 'clusterActiveTable';
export const CAC_CLUSTER_TABLE_TYPE = 'clusterTableType';
export const CAC_CLUSTER_SEG_COMPARISON_TITLE = 'Segment Comparison';
export const CAC_CLUSTER_SEG_COMPARISON_TABLE = 'segment';
export const CAC_CORR_DEFAULT_SORT_KEY_PRIMARY = 'ctr1';
export const CAC_CORR_DEFAULT_SORT_KEY_SECONDARY = 'ctr2';
export const CAC_CLUSTER_DEFAULT_SORT_KEY = 'varianceExplainedValues';

export const CAC_ALREADY_SAVE_PROJECT_BEFORE_CLOSE_LABEL =
  'You have made some changes to this saved project, would you like to save the changes?';
export const CAC_CLUSTER_SAVE_POPUP_TITLE = 'Enter solution name';  
export const CAC_CLUSTER_ALREADY_USED_NAME = 'This name has already been taken, please enter a new name';
export const SAVE_SOLUTION_BTN_TITLE = "SAVE THIS SOLUTION";
export const CAC_ROUTER_LEAVE_LABEL = 'Are you sure you want to continue? Your projects will not be saved if you click OK';
export const CAC_TEASER_TITLE = 'Correspondence and Clustering is available now.';
export const CAC_TEASER_MESSAGE = `Our updated Correspondence & Cluster Analysis tool is now in beta.
  Correspondence Analysis reveals the relative relationships between and within two groups of variables.
  You can use this module to discover relationships between brands and user behaviors, to compare brands, media,
 and audience groups, etc. or just to explore general consumer behaviors.`;
export const CAC_NO_STUDIES = `You do not currently have studies to the Correspondence and Clustering application.
 Please contact your Account Manager to learn more about your studies.`;
export const CAC_CLUSTER_EMPTY_NAME = 'Name can not be blank, please enter valid name';
export const CLUSTER_ERROR_MESSAGE = 'The selected data does not support cluster mapping';
export const CORR_ERROR_MESSAGE = 'The selected data does not support correspondence mapping';
export const CAC_AXES_DISPLAY_FRONT_VIEW = 'Front View';
export const CAC_AXES_DISPLAY_TOP_VIEW = 'Top View';
export const CAC_AXES_DISPLAY_SIDE_VIEW = 'Side View';
